import { useLingui } from '../../../../../../../../node_modules/@lingui/react/dist/index.mjs';
import React__default from 'react';
import { PasskeyIcon } from '../../../../../assets/passkeys.mjs';
import Button from '../../../../components/atoms/Button.mjs';

const PasskeyButton = ({ startPasskeyAuth })=>{
    const { i18n: $__i18n, _: $__ } = useLingui();
    return /*#__PURE__*/ React__default.createElement(Button, {
        icon: /*#__PURE__*/ React__default.createElement(PasskeyIcon, null),
        variant: "outline",
        onClick: startPasskeyAuth
    }, $__i18n._({
        id: "button.loginWithPasskey"
    }));
};

export { PasskeyButton };
//# sourceMappingURL=PasskeyButton.mjs.map
